// extracted by mini-css-extract-plugin
module.exports = {"container":"TiberSynth-container-2Lt-e","sidebar":"TiberSynth-sidebar-34QcE","visualization":"TiberSynth-visualization-2rufk"};